import * as t from 'io-ts';

const Client = t.exact(t.interface({
  checkVersionInterval: t.number,
  clientExpiryTimeout: t.number,
}), 'Client');

export type IClient = t.TypeOf<typeof Client>;

export default Client;
